import SectionSearchHero from './SectionSearchHero';
export default SectionSearchHero;
